import './ProfileMaintenance.scss';

import React from "react";
import ErrorPage from 'components/shared/ErrorPage/ErrorPage';

class ProfileMaintenance extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="profile-maintenance"
           id="profile-maintenance">
          <ErrorPage summaryMessage="We're working on this feature and it will be available soon.">
            <div />
          </ErrorPage>
      </div>
    );
  }
}

export default ProfileMaintenance;